<template>
  <div class="card-container" style="justify-content: space-between;">
    <div class="card-container" style="justify-content: center;"
    >
      <div class="qr-scanner-container" v-if="capturedImageUrl == null">
        <slot />
        <div class="qr-frame pending-qr-frame"></div>
      </div>
      <div v-else class="qr-scanner-container">
        <img
          :src="capturedImageUrl"
          alt="Prévia"
          class="camera-feed image-preview"
        />
      </div>
    </div>
    <button class="input-option--btn" @click="handleInsertCode">
      Inserir código
    </button>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: ["capturedImageUrl"],
  emits: ["onInsertCode"],
  methods: {
    handleInsertCode() {
      this.$emit("onInsertCode");
    },
  },
};
</script>
<style scoped>
.qr-scanner-container {
  position: relative;
  width: 60%;
  aspect-ratio: 1/1;
  overflow: hidden;
  border-radius: 4px;
  /* background-color: #000; */
}

.card-container {
  width: 100%;
  height: 90%;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.qr-frame {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  height: 90%;
  border-radius: 4px;
  pointer-events: none;
  box-shadow: 0 0 0 100vmax #ececec;
  object-fit: cover;
  animation: pulse 2s infinite;
}

.pending-qr-frame {
  border: 2px solid rgba(232, 107, 83, 0.7);
}

.active-qr-frame {
  border: 3px solid rgba(43, 223, 73, 0.7);
}

.input-option--btn {
  font-size: 14px;
  color: #de3517;
  opacity: 0.8;
  font-weight: 500;
  text-decoration: underline;
  margin-top: 10px;
  background-color: transparent;
  border: none;
}
</style>
